"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bind = void 0;
/* eslint @typescript-eslint/no-explicit-any: 0 */
/* eslint @typescript-eslint/ban-ts-comment: 0 */
const immer_1 = require("immer");
const Y = __importStar(require("yjs"));
const util_1 = require("./util");
(0, immer_1.enablePatches)();
function applyYEvent(base, event) {
    if (event instanceof Y.YMapEvent && (0, util_1.isJSONObject)(base)) {
        const source = event.target;
        event.changes.keys.forEach((change, key) => {
            switch (change.action) {
                case 'add':
                case 'update':
                    base[key] = (0, util_1.toPlainValue)(source.get(key));
                    break;
                case 'delete':
                    delete base[key];
                    break;
            }
        });
    }
    else if (event instanceof Y.YArrayEvent && (0, util_1.isJSONArray)(base)) {
        const arr = base;
        let retain = 0;
        event.changes.delta.forEach((change) => {
            if (change.retain) {
                retain += change.retain;
            }
            if (change.delete) {
                arr.splice(retain, change.delete);
            }
            if (change.insert) {
                if (Array.isArray(change.insert)) {
                    arr.splice(retain, 0, ...change.insert.map(util_1.toPlainValue));
                }
                else {
                    arr.splice(retain, 0, (0, util_1.toPlainValue)(change.insert));
                }
                retain += change.insert.length;
            }
        });
    }
}
function applyYEvents(snapshot, events) {
    // @ts-ignore
    return (0, immer_1.produce)(snapshot, (target) => {
        for (const event of events) {
            const base = event.path.reduce((obj, step) => {
                // @ts-ignore
                return obj[step];
            }, target);
            applyYEvent(base, event);
        }
    });
}
const PATCH_REPLACE = 'replace';
const PATCH_ADD = 'add';
const PATCH_REMOVE = 'remove';
function defaultApplyPatch(target, patch) {
    const { path, op, value } = patch;
    if (!path.length) {
        if (op !== PATCH_REPLACE) {
            (0, util_1.notImplemented)();
        }
        if (target instanceof Y.Map && (0, util_1.isJSONObject)(value)) {
            target.clear();
            for (const k in value) {
                target.set(k, (0, util_1.toYDataType)(value[k]));
            }
        }
        else if (target instanceof Y.Array && (0, util_1.isJSONArray)(value)) {
            target.delete(0, target.length);
            target.push(value.map(util_1.toYDataType));
        }
        else {
            (0, util_1.notImplemented)();
        }
        return;
    }
    let base = target;
    for (let i = 0; i < path.length - 1; i++) {
        const step = path[i];
        base = base.get(step);
    }
    const property = path[path.length - 1];
    if (base instanceof Y.Map && typeof property === 'string') {
        switch (op) {
            case PATCH_ADD:
            case PATCH_REPLACE:
                base.set(property, (0, util_1.toYDataType)(value));
                break;
            case PATCH_REMOVE:
                base.delete(property);
                break;
        }
    }
    else if (base instanceof Y.Array && typeof property === 'number') {
        switch (op) {
            case PATCH_ADD:
                base.insert(property, [(0, util_1.toYDataType)(value)]);
                break;
            case PATCH_REPLACE:
                base.delete(property);
                base.insert(property, [(0, util_1.toYDataType)(value)]);
                break;
            case PATCH_REMOVE:
                base.delete(property);
                break;
        }
    }
    else if (base instanceof Y.Array && property === 'length') {
        if (value < base.length) {
            const diff = base.length - value;
            base.delete(value, diff);
        }
    }
    else {
        (0, util_1.notImplemented)();
    }
}
function applyUpdate(source, snapshot, fn, applyPatch) {
    const [, patches] = (0, immer_1.produceWithPatches)(snapshot, fn);
    for (const patch of patches) {
        applyPatch(source, patch);
    }
}
/**
 * Bind y.js data type.
 * @param source The y.js data type to bind.
 * @param options Change default behavior, can be omitted.
 */
function bind(source, options) {
    let snapshot = source.toJSON();
    const get = () => snapshot;
    const subscription = new Set();
    const subscribe = (fn) => {
        subscription.add(fn);
        return () => void subscription.delete(fn);
    };
    const observer = (events) => {
        snapshot = applyYEvents(get(), events);
        subscription.forEach((fn) => fn(get()));
    };
    source.observeDeep(observer);
    const unbind = () => source.unobserveDeep(observer);
    const applyPatchInOption = options ? options.applyPatch : undefined;
    const applyPatch = applyPatchInOption
        ? (target, patch) => applyPatchInOption(target, patch, defaultApplyPatch)
        : defaultApplyPatch;
    const update = (fn) => {
        const doc = source.doc;
        const doApplyUpdate = () => {
            applyUpdate(source, get(), fn, applyPatch);
        };
        if (doc) {
            Y.transact(doc, doApplyUpdate);
        }
        else {
            doApplyUpdate();
        }
    };
    return {
        unbind,
        get,
        update,
        subscribe,
    };
}
exports.bind = bind;
//# sourceMappingURL=immer-yjs.js.map